


























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapGetters } from 'vuex'
import FloorModel from '@/_models/FloorModel'

@Component({
  components: {},
})
export default class SearchFloor extends Vue {
  // Props
  @Prop()
  selectedData!: any

  // data
  currentPage: number = 1
  perPage: number = 10
  numofPage: number = 1
  selected: any = {}
  isFormModalActive: boolean = false
  isMapAdjustActive: boolean = false
  searchQuery: string = ''
  selectedFilter: string = 'name'
  filedNameLUT: any = {
    _id: 'ID',
    name: 'label.floor_name',
    building_name: 'label.building_name',
    // num_beacon: 'label.num_beacon',
  }

  // computed
  get floors(): FloorModel[] {
    const floors = this.$store.state.floors.all.items
    this.numofPage = Math.ceil(floors.length / this.perPage)

    return floors
  }

  get isLoading(): boolean {
    return this.$store.state.floors.loading
  }

  get filteredData(): FloorModel[] {
    const targetField: string = this.selectedFilter
    if (!this.floors) {
      return []
    }

    return this.floors.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  // methods
  handleSelectFinished(): void {
    const selectedData = {
      _id: this.selected._id || '',
      name: this.selected.name || '',
    }

    this.$emit('handleSelectedFloorDone', selectedData)
  }

  handleToggleSelected(): void {
    if (this.selected._id) {
      this.selected = {}
    }
  }

  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  // After page created
  created() {
    this.$store.dispatch('floors/getAll').then(() => {
      for (const item of this.filteredData) {
        if (
          typeof this.selectedData !== 'undefined' &&
          this.selectedData &&
          item._id === this.selectedData._id
        ) {
          this.selected = item
          return
        }
      }
    })
  }
}
